import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Card, ProfileCompletionBar } from 'components'
import { useCommunity } from 'utils'
import {
  buildBarModel,
  buildProfileCompletionOptions,
} from '../../profile/profile-completion-sections'

const propTypes = {
  partner: Types.partner.isRequired,
  profileCompletionBarOptions: PropTypes.object,
}

const defaultProps = {
  profileCompletionBarOptions: {},
}

function ProfileCompletionCard({ partner, profileCompletionBarOptions }) {
  const [, setBarVersion] = useState(0)

  useEffect(() => {
    const onProfileCompletionUpdated = () => {
      setBarVersion((prev) => prev + 1)
    }
    if (typeof window !== 'undefined') {
      window.addEventListener(
        'profile-completion-updated',
        onProfileCompletionUpdated
      )
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener(
          'profile-completion-updated',
          onProfileCompletionUpdated
        )
      }
    }
  }, [])

  const community = useCommunity()
  const { sections, completedSections, percent } = buildBarModel(
    partner,
    community,
    profileCompletionBarOptions
  )

  return (
    <Card>
      <ProfileCompletionBar
        variant="card"
        percent={percent}
        completedSections={completedSections}
        sections={sections}
      />
    </Card>
  )
}

ProfileCompletionCard.propTypes = propTypes
ProfileCompletionCard.defaultProps = defaultProps

function mapStateToProps(state) {
  return {
    profileCompletionBarOptions: buildProfileCompletionOptions(state),
  }
}

export default compose(connect(mapStateToProps))(ProfileCompletionCard)
